import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EInvoicingRegistrationsTable } from "@/components/EInvoicingRegistrationsTable";

/** Every organisation's registration attempt, across clients. The state filter lives on the table so the client page shares it. */
export function EInvoicingRegistrationsPage() {
  const [refreshKey, setRefreshKey] = useState(0);

  // Also refresh on an interval: registrations move when the provider calls back, sometimes days later.
  useEffect(() => {
    const timer = setInterval(() => setRefreshKey((k) => k + 1), 60_000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <div className="mb-1 flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold">E-Invoicing Registrations</h1>
        <Button variant="outline" size="sm" onClick={() => setRefreshKey((k) => k + 1)}>
          <RefreshCw className="mr-2 size-4" />
          Refresh
        </Button>
      </div>
      <p className="mb-6 max-w-3xl text-sm text-muted-foreground">
        Becoming a network participant is a multi-day conversation with an access point: it can stall
        at approval, be refused for a tax number already on the network, or wait on a
        proof-of-ownership document nobody uploaded. Each row carries the provider&apos;s own account
        of what happened, including which workflow step failed and when. Newest first, paged.
      </p>

      <EInvoicingRegistrationsTable refreshKey={refreshKey} />
    </div>
  );
}
